var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    staticClass: "transitionBorder_svg__a transitionBorder_svg__arc",
    attrs: {
      "viewBox": "0 0 1517 93",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "d": "M0 92.067c528.5-121 977.5-124.5 1516.5 0H0z",
      "fill": "currentColor"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }